import { inject, Injectable } from '@angular/core';
import { AuthService, IAuthToken, RouterService } from '@resident-nx/shared';
import { KeycloakService } from './keycloak.service';

@Injectable({
  providedIn: 'root',
})
export class AuthWebService extends AuthService {
  private router = inject(RouterService);
  private routerService = inject(RouterService);
  #keycloakService = inject(KeycloakService);

  // todo refactor this ****
  public login(): Promise<IAuthToken> {
    return undefined;
  }

  public logout(redirection?: string): void {
    switch (redirection) {
      case 'unauthorized':
        this.router.navigate(['unauthorized-user']);
        break;

      case 'downtime':
        this.router.navigate(['downtime']);
        break;

      default:
        this.router.navigate(['logout']);
    }
  }

  // TODO add token refresh call, update IAuthToken in storage

  public refresh(): Promise<IAuthToken> {
    const authToken = {} as IAuthToken;
    return Promise.resolve(authToken);
  }

  public guestLogin(): boolean {
    this.guestMode = true;
    return this.guestMode;
  }

  public isGuestMode(): boolean {
    return this.guestMode;
  }

  public getToken(): IAuthToken {
    return { accessToken: this.#keycloakService.token };
  }

  override navigateToUnverifiedScreen() {
    void this.routerService.navigate(['unverified']);
  }
}
